import { POI_ANALYSIS_ACTIONS, POI_ANALYSIS_MENU_ACTION } from './poiAnalysisActions.js';
import { openProximityAnalysisDialog } from './proximityAnalysisDialog.js';

let menuElement = null;

function closeMenu() {
  if (menuElement) menuElement.style.display = 'none';
}

function createMenu() {
  const menu = document.createElement('div');
  menu.className = 'poi-context-menu poi-set-context-menu';
  menu.setAttribute('role', 'menu');
  menu.setAttribute('aria-label', 'Point of Interest set actions');
  Object.assign(menu.style, { position: 'fixed', display: 'none', zIndex: '10030' });
  menu.addEventListener('contextmenu', event => event.preventDefault());
  menu.addEventListener('pointerdown', event => event.stopPropagation());
  menu.addEventListener('pointerleave', closeMenu);
  const heading = document.createElement('div');
  heading.className = 'poi-context-menu-heading';
  heading.innerHTML = '<span class="poi-context-menu-heading-icon"><img alt="" hidden><i class="bi bi-layers-fill" aria-hidden="true"></i></span><span class="poi-context-menu-heading-copy"><strong class="poi-context-set-name"></strong></span>';
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'poi-context-menu-item';
  button.setAttribute('role', 'menuitem');
  button.innerHTML = `<i class="bi ${POI_ANALYSIS_MENU_ACTION.icon}" aria-hidden="true"></i><span>${POI_ANALYSIS_MENU_ACTION.label}</span>`;
  menu.append(heading, button);
  document.body.appendChild(menu);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMenu();
  });
  return menu;
}

export function showPoiSetContextMenu({ clientX, clientY, poiSetId, poiSetName, layers = [] }) {
  if (!poiSetId) return;
  menuElement ||= createMenu();
  menuElement.querySelector('.poi-context-set-name').textContent = String(poiSetName || 'Point of Interest Set');
  const iconSrc = layers.find(layer => layer?.get?.('poiLegendIconSrc'))?.get?.('poiLegendIconSrc');
  const image = menuElement.querySelector('.poi-context-menu-heading-icon img');
  const fallback = menuElement.querySelector('.poi-context-menu-heading-icon i');
  image.hidden = !iconSrc;
  image.src = iconSrc || '';
  fallback.hidden = !!iconSrc;
  menuElement.querySelectorAll('.poi-context-menu-item').forEach(button => {
    button.onclick = event => {
      event.preventDefault();
      event.stopPropagation();
      closeMenu();
      openProximityAnalysisDialog(POI_ANALYSIS_ACTIONS[0], { targetType: 'poi-set', poiSetId, poiSetName, layers });
    };
  });
  menuElement.style.display = 'block';
  menuElement.style.visibility = 'hidden';
  const margin = 10;
  const width = menuElement.offsetWidth || 200;
  const height = menuElement.offsetHeight || 130;
  menuElement.style.left = `${Math.max(margin, Math.min(clientX, window.innerWidth - width - margin))}px`;
  menuElement.style.top = `${Math.max(margin, Math.min(clientY, window.innerHeight - height - margin))}px`;
  menuElement.style.visibility = 'visible';
  menuElement.querySelector('button')?.focus({ preventScroll: true });
}
